// Funkcje premium w panelu (FAZA F, F.2): rozpoznanie odpowiedzi 403 `premium_required`
// z serwera (Login/backend/lib/plans.js#odpowiedzPremium) i treść zgłoszenia „Chcę Premium”.
// Bez Reacta, żeby dało się to sprawdzić testem jednostkowym.

export const KOD_PREMIUM = 'premium_required';

// Slug funkcji z serwera (`FUNKCJE_PREMIUM`) → klucz nazwy w translations.js. Klucze jako `labelKey`,
// bo audyt tłumaczeń rozpoznaje tak klucze trzymane w danych (scripts/audit-translations.js).
const FUNKCJE = {
  widget: { labelKey: 'premium.feature.widget' },
  own_smtp: { labelKey: 'premium.feature.own_smtp' },
  reminders: { labelKey: 'premium.feature.reminders' },
  sms: { labelKey: 'premium.feature.sms' },
  payment_links: { labelKey: 'premium.feature.payment_links' },
  booking_link: { labelKey: 'premium.feature.booking_link' },
  unpaid_guard: { labelKey: 'premium.feature.unpaid_guard' },
};
const FUNKCJA_INNA = { labelKey: 'premium.feature.other' };

export function kluczNazwyFunkcji(feature) {
  return (Object.prototype.hasOwnProperty.call(FUNKCJE, feature) ? FUNKCJE[feature] : FUNKCJA_INNA).labelKey;
}

/**
 * Odmowa planu z odpowiedzi serwera: ciało JSON (fetch) albo wyjątek axios (`err.response.data`).
 * Zwraca `{ feature, message }` albo null, gdy to inna odpowiedź.
 */
export function bladPremium(zrodlo) {
  if (!zrodlo || typeof zrodlo !== 'object') return null;
  const dane = zrodlo.response && zrodlo.response.data && typeof zrodlo.response.data === 'object'
    ? zrodlo.response.data
    : zrodlo;
  if (dane.code !== KOD_PREMIUM) return null;
  return {
    feature: typeof dane.feature === 'string' ? dane.feature : null,
    message: typeof dane.error === 'string' ? dane.error : '',
  };
}

/** Kategoria, temat i treść okna zgłoszenia (components/help/SupportRequestModal.js) dla „Chcę Premium”. */
export function zgloszenieChcePremium(t, feature) {
  return {
    kategoria: 'question',
    temat: t('premium.request.subject'),
    tresc: t('premium.request.body', { feature: t(kluczNazwyFunkcji(feature)) }),
  };
}
